<template>
    <section class="mine-help-item">
        <div class="mine-help-item-title"
            :class="{ 'folded': isFolded }"
            @click="() => { isFolded = !isFolded }">
            <span>{{ dataSource.title }}</span>
        </div>
        <div class="mine-help-item-content"
            :class="{ 'folded': isFolded }">
            {{ dataSource.desc }}
            <div class="mine-help-item-button">
                <div @click="handleClick(0)"
                    :class="{ 'active': activeButtonIndex === 0 }">已解决</div>
                <div @click="handleClick(1)"
                    :class="{ 'active': activeButtonIndex === 1 }">未解决</div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: 'MineHelpItem',
  props: {
    dataSource: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isFolded: true,
      activeButtonIndex: null
    }
  },
  methods: {
    handleClick (index) {
      this.activeButtonIndex = index
      this.$emit('click', this.dataSource, index)
    }
  }
}
</script>

<style lang="scss" scoped>
    @import '../../style/main';

    @mixin setIconBg($image) {
        &::before {
            background: {
                image: url(#{ $image });
                repeat: no-repeat;
                size: contain;
            }
        }
    }

    .mine-help-item {
        background-color: #fff;
        font-family: PingFangSC-Regular;

        &-title {
            position: relative;
            margin-left: rem(30);
            padding: rem(30) 0;
            font-size: rem(28);
            color: #333;

            &.folded {
                border-bottom: 1px solid #e4e4e4;

                &::after {
                    transform: translateY(-50%) rotate(180deg);
                }
            }

            & > span {
                display: inline-block;
                max-width: rem(600);
                line-height: 1.5;
            }

            &::after {
                $size: rem(12);
                content: '';
                transition: transform .15s linear;
                transform: translateY(-50%);
                position: absolute;
                top: 50%;
                right: rem(30);
                width: $size * 2;
                height: $size;
                background: {
                    image: url('../../assets/images/pay-icon-arrow.png');
                    repeat: no-repeat;
                    size: contain;
                }
            }
        }

        &-content {
            transition: all .15s linear;
            transform: scaleY(1);
            transform-origin: top;
            padding: rem(30) rem(30) rem(40);
            line-height: 1.5;
            background-color: #f3f4f6;
            font-size: rem(26);
            color: #666;

            &.folded {
                transform: scaleY(0);
                padding: 0 rem(30);
                height: 0;
                opacity: 0;
            }
        }

        &-button {
            $w: rem(208);
            $offset: rem(24);

            margin: rem(100) auto 0;
            width: $w * 2 + $offset;

            & > div {
                display: inline-block;
                box-sizing: border-box;
                padding: rem(20) 0;
                width: $w;
                border: 1px solid #bfbfbf;
                border-radius: 2px;
                text-align: center;
                font-size: rem(28);
                color: #666;

                &:first-child {
                    margin-right: $offset;
                    @include setIconBg('../../assets/images/help-icon-like-g.png');

                    &.active {
                        @include setIconBg('../../assets/images/help-icon-like-y.png');
                    }
                }

                &:last-child {
                    @include setIconBg('../../assets/images/help-icon-unlike-g.png');

                    &.active {
                        @include setIconBg('../../assets/images/help-icon-unlike-y.png');
                    }
                }

                &.active {
                    border-color: #f48f00;
                    background-color: #ffefd7;
                    color: #f48f00;
                }

                &::before {
                    $size: rem(30);

                    content: '';
                    display: inline-block;
                    vertical-align: middle;
                    margin-right: rem(24);
                    width: $size;
                    height: $size;
                }
            }
        }
    }
</style>
